export const mantenimientoHeroImage =
  "https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20in%20blue%20uniform%20performing%20preventive%20maintenance%20on%20commercial%20air%20conditioning%20unit%2C%20cleaning%20filters%20with%20tools%2C%20modern%20industrial%20interior%2C%20clean%20bright%20environment%2C%20warm%20natural%20lighting%2C%20editorial%20photography%20style%2C%20teal%20blue%20accent%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=800&seq=mantenimiento-hero-1&orientation=landscape";

export const mantenimientoIntroImage =
  "https://readdy.ai/api/search-image?query=Close%20up%20of%20technician%20hands%20cleaning%20air%20conditioner%20filter%20with%20brush%2C%20dust%20particles%20visible%2C%20professional%20HVAC%20maintenance%20service%2C%20clean%20workshop%20background%2C%20soft%20natural%20lighting%2C%20editorial%20industrial%20photography%2C%20teal%20blue%20tones%2C%20high%20detail&width=800&height=600&seq=mantenimiento-intro-1&orientation=landscape";

export const mantenimientoBenefits = [
  {
    title: "Ahorro de hasta un 30% en consumo de energía",
    description:
      "Un equipo limpio y ajustado trabaja menos y consume menos. Ese ahorro se refleja directo en tu factura.",
    icon: "ri-money-dollar-circle-line",
  },
  {
    title: "Evita reparaciones costosas",
    description:
      "El 70% de las averías graves se originan por falta de mantenimiento. Detectamos fallas antes de que se conviertan en un gasto mayor.",
    icon: "ri-alert-line",
  },
  {
    title: "Prolonga la vida útil de tu equipo",
    description:
      "Un aire acondicionado bien mantenido puede durar años más. Protege tu inversión con un plan preventivo.",
    icon: "ri-time-line",
  },
  {
    title: "Aire más saludable para tu familia o equipo",
    description:
      "Eliminamos polvo, ácaros y bacterias acumulados. Mejora la calidad del aire que respiras cada día.",
    icon: "ri-heart-pulse-line",
  },
  {
    title: "Máximo rendimiento cuando más lo necesitas",
    description:
      "Evita que tu equipo falle justo en los días de más calor. Garantiza confort continuo todo el año.",
    icon: "ri-temp-hot-line",
  },
  {
    title: "Cumplimiento y tranquilidad legal",
    description:
      "Para cuartos fríos e industrias, mantenemos tus sistemas dentro de la normativa sanitaria y de seguridad.",
    icon: "ri-shield-check-line",
  },
] as const;

export const mantenimientoStats = [
  { value: "70%", label: "de averías graves se evitan con mantenimiento" },
  { value: "30%", label: "de ahorro promedio en consumo de energía" },
  { value: "+15 años", label: "prolongando la vida útil de tus equipos" },
  { value: "365 días", label: "atención prioritaria para clientes con plan" },
] as const;

export const mantenimientoWhyChoose = [
  {
    title: "Técnicos certificados y especializados en refrigeración",
    icon: "ri-award-line",
  },
  {
    title: "Cobertura nacional en toda Colombia",
    icon: "ri-map-pin-line",
  },
  {
    title: "Repuestos originales con garantía de fábrica",
    icon: "ri-verified-badge-line",
  },
  {
    title: "Reportes técnicos claros con fotos del antes y después",
    icon: "ri-file-list-3-line",
  },
  {
    title: "Contratos flexibles según la necesidad de tu negocio",
    icon: "ri-hand-heart-line",
  },
  {
    title: "Atención de emergencias prioritaria para clientes con plan",
    icon: "ri-customer-service-2-line",
  },
] as const;